import { apiBase } from "./client";

/** Private media lives on the API, not on Cloudflare Pages. Never accept script URLs. */
export function mediaUrl(
  value?: string | null,
  base = apiBase(),
): string | undefined {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) {
    try {
      const url = new URL(value);
      return url.username || url.password ? undefined : url.href;
    } catch {
      return undefined;
    }
  }
  if (
    /^\/(api|media|uploads)\//.test(value) &&
    !value.includes("\\") &&
    !value.includes("..")
  )
    return `${base}${value}`;
  return undefined;
}
